import React from "react";
import { connect } from 'react-redux';
import TextInput from '@zacousticrepo/grommet-v1-custom/components/TextInput';
import RadioButton from '@zacousticrepo/grommet-v1-custom/components/RadioButton';
//import FormControl from '@material-ui/core/FormControl/FormControl';
//import RadioGroup from '@material-ui/core/RadioGroup/RadioGroup';
//import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
//import Radio from '@material-ui/core/Radio/Radio';
import { roleType } from '../../../constants';
import { isDefined } from "../../../utils";

class UserCreator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            roleId: roleType.agent,
            name: undefined,
            email: undefined,
        };
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.closeAndCreate = this.closeAndCreate.bind(this);
        this.selectSurveyFormType = this.selectSurveyFormType.bind(this);

        this.updateName = this.updateName.bind(this);
        this.updateEmail = this.updateEmail.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        const
            {
                onClose
            } = this.props;

        if (this.wrapperRef) {
            if (!this.wrapperRef.current.contains(event.target)) {
                onClose();
            }
        }
    }

    closeAndCreate() {
        const
            {
                onClose
            } = this.props;
        onClose(this.state.name, this.state.email, this.state.roleId, this.state.id, this.state.teamId);
    }

    updateName({ target }) {
        this.setState({ name: target.value });
    }

    updateEmail({ target }) {
        this.setState({ email: target.value });
    }

    updateId = ({ target }) => {
        this.setState({ id: target.value });
    }

    selectSurveyFormType(roleId) {
        this.setState({ roleId: roleId });
    }

    handleSelectChange = ({ target }) => {
        this.setState({ teamId: target.value });
    }

    allRequiredQuestionsAreAnswered = () => {

        if (!isDefined(this.state.email) || this.state.email === '') {
            return false;
        }
        if (!isDefined(this.state.name) || this.state.name === '') {
            return false;
        }
        if (this.state.roleId == roleType.agent && (!isDefined(this.state.id) || this.state.id === '')) {
            return false;
        }
        if (this.state.roleId == roleType.agent && (!isDefined(this.state.teamId) || this.state.teamId === '')) {
            return false;
        }
        return true;
    }

    render() {
        const
            {
                allTeams
            } = this.props;
        let textInput;

        const distinctTeams = allTeams.reduce((acc, current) => {
            if (isDefined(current.id) && isDefined(current.name) && !acc.some(item => item.teamId === current.id)) {
                acc.push({ team: current.name, teamId: current.id });
            }
            return acc;
        }, []);

        const sortedDistinctTeams = [...distinctTeams].sort((a, b) => {
            return a.team.localeCompare(b.team);
        });

        const enabledsubmitSurveyButton = (
            <div className="v3-button session-required" style={{ borderRadius: '10px' }}
                onClick={this.closeAndCreate}>
                <label className="h3-semibold white-text cursor-pointer">Create User</label>
            </div>);

        const disabledsubmitSurveyButton = (
            <div className="v3-button session-required-disabled" style={{ cursor: 'auto', borderRadius: '10px' }}>
                <label className="h3-semibold grey-text" >Create User</label>
            </div >);


        const submitSurveyButton =
            (this.state.surveyIsSubmitting || !this.allRequiredQuestionsAreAnswered())
                ? disabledsubmitSurveyButton : enabledsubmitSurveyButton;

        return (<div className="modal displayBlock" >
            <div className="modal-content modal-create-team" ref={this.wrapperRef}>
                <div className="eighteen-regular-primary-color" >
                    Name
                </div>
                <div className="flex-container" style={{ margin: '20px auto' }}>
                    <TextInput
                        className="rectangle-18560"
                        id={"1"}
                        name={"min"}
                        onDOMChange={this.updateName}
                        value={textInput}
                    />
                </div>
                <div className="eighteen-regular-primary-color" >
                    Id
                </div>
                <div className="flex-container" style={{ margin: '20px auto' }}>
                    <TextInput
                        className="rectangle-18560"
                        id={"1"}
                        name={"min"}
                        onDOMChange={this.updateId}
                        value={textInput}
                    />
                </div>
                <div className="eighteen-regular-primary-color" >
                    Email
                </div>
                <div className="flex-container" style={{ margin: '20px auto' }}>
                    <TextInput
                        className="rectangle-18560"
                        id={"1"}
                        name={"min"}
                        onDOMChange={this.updateEmail}
                        value={textInput}
                    />
                </div>
                <div>
                    <select value={this.state.teamId} onChange={this.handleSelectChange}
                        className="dropdown_list" style={{ width: '295px', border: '1px solid #AEC1DA' }}>
                        <option value="">Select Team</option>
                        {sortedDistinctTeams && sortedDistinctTeams.map((option) => (
                            <option key={option.id} value={option.teamId}>
                                {option.team}
                            </option>
                        ))}
                    </select>
                </div>
                <div style={{ margin: '20px auto' }}>
                    <div className="eighteen-regular-primary-color " style={{ margin: '32px 0 16px 0' }}>Role</div>
                    <div className="radio-button-text">
                        <div style={{ margin: '10px' }}>
                            <RadioButton id="agent" label='Agent' checked={this.state.roleId === roleType.agent}
                                onChange={() => this.selectSurveyFormType(roleType.agent)} />
                        </div>
                        <div style={{ margin: '10px' }}>
                            <RadioButton id="supervisor" label='supervisor' checked={this.state.roleId === roleType.supervisor}
                                onChange={() => this.selectSurveyFormType(roleType.supervisor)} />

                        </div>
                        <div style={{ margin: '10px' }}>
                            <RadioButton id="manager" label='manager' checked={this.state.roleId === roleType.manager}
                                onChange={() => this.selectSurveyFormType(roleType.manager)} />
                        </div>
                        <div style={{ margin: '10px' }}>
                            <RadioButton id="admin" label='admin' checked={this.state.roleId === roleType.admin}
                                onChange={() => this.selectSurveyFormType(roleType.admin)} />
                        </div>
                        <div style={{ margin: '10px' }}>
                            <RadioButton id="superAdmin" label='superAdmin' checked={this.state.roleId === roleType.superAdmin}
                                onChange={() => this.selectSurveyFormType(roleType.superAdmin)} />
                        </div>
                    </div>
                </div>
                {submitSurveyButton}
            </div>
        </div>);
    };
}

const select = state => ({});

export default connect(select)(UserCreator);

